const smtMain = {
  breadcrumb: {
    active: {
      color: {
        default: 'gray.800',
        _dark: 'gray.400'
      }
    },
    inactive: {
      color: {
        default: 'gray.400',
        _dark: 'gray.600'
      },
      hover: {
        color: {
          default: 'gray.900',
          _dark: 'gray.400'
        }
      }
    }
  },
  bottomNav: {
    linkHoverColor: {
      default: 'theme.800',
      _dark: 'theme.300'
    }
  }
};

export default smtMain;
